export interface DelegationParams {
  id: number;
  endDate: string;
  startDate: string;
}

export interface DelegationUoVo {
  createdBy: string;
  deleted: boolean;
  label: string;
  name: string;
  uoId: string;
  updatedBy: string;
}

export interface DelegationRequestModel {
  id: string;
  createdBy: string;
  delegate: string;
  delegationParams: DelegationParams;
  delegationUoVo: DelegationUoVo[];
  deleted: boolean;
  fullName: string;
  site: string;
  dirSite: string;
  function: string;
}

export interface DelegationHabilitationParams {
  id: number;
  label: string;
  title: string;
  startDate: string;
  endDate: string;
  activate: boolean;
}


export interface DelegationHabilitationParamsVO {
  id: number;
  label: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  name: string;
  deleted: boolean;
}

export interface DelegationHabilitation {
  id: number;
  startDate: string;
  endDate: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  deleted: boolean;
  delegationHabilitationParamsVO: DelegationHabilitationParamsVO;
}

export interface DelegationUo {
  label: string;
  name: string;
  uoId: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  deleted: boolean;
}

export interface DelegationItem {
  id: number;
  dirSite: string;
  delegate: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  deleted: boolean;
  delegationHabilitation: DelegationHabilitation;
  delegationUoList: DelegationUo[];
}

export enum TypeSelectDelegation {
  UO = 'UO',
  COLLABORATORS  = 'COLLABORATORS'
}








// WEBPACK FOOTER //
// ./src/app/modules/delegation/delegation.model.ts